import React from 'react';

const IconTwitter = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-youtube">
        <title>YouTube</title>
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="none" stroke="currentColor" />
        <polygon points="10 8 16 12 10 16 10 8" fill="currentColor" />
    </svg>
);

export default IconTwitter;
